import { ls } from './config.js';
import { dataObject } from './data-object.js';

const coursesOverviewTableHeadings = [
	{data: 'ID', title: 'ID'},
	{data: 'course', title: reportingApiSetup.learnDashLabels.course},
	{data: 'enrolled', title: ls('Enrolled')},
	{data: 'notStarted', title: ls('Not Started')},
	{data: 'inProgress', title: ls('In Progress')},
	{data: 'completed', title: ls('Completed')},
	{
		data: 'avgQuizScore',
		data: 'avgQuizScore',
		title: sprintf(reportingApiSetup.localizedStrings.tablesColumnsAvgQuizScore, reportingApiSetup.learnDashLabels.quiz)
	},
	{data: 'percentComplete', title: ls('% Complete')},
	{data: 'details', 'title': reportingApiSetup.localizedStrings.tablesColumnsDetails, className: 'no-sort'}
];

const coursesOverviewTableData = function () {


	var courseList = dataObject.getCourseList();
	var userList = dataObject.getUserList();

	// Default values
	var tableData = [];
	var userAverages = [],
		i = 0,
		courseAssociatedPosts,
		courseID,
		courseName,
		courseType;

	// Loop through all courses
	jQuery.each(courseList, function (courseId, courseData) {


		var userAccess = [],
			enrolled = 0,
			notStarted = 0,
			inProgress = 0,
			completed = 0,
			avgQuiz = '',
			avgCompletionTime = '',
			avgTimeSpent = '',
			completion = '';

		courseID = courseId;
		courseName = courseData.post_title;
		courseType = courseData.course_price_type;

		if ('' === courseName) {
			courseName = sprintf(reportingApiSetup.localizedStrings.missingTitleCourseId, reportingApiSetup.learnDashLabels.course) + courseData.ID;
		}

		if ('open' === courseType) {
			enrolled = Object.keys(userList.allUserIds).length;
			userAccess = userList.allUserIds;
		} else {

			if ("1" === reportingApiSetup.optimized_build) {
				if (userList?.course_user_access_list?.[courseID] !== undefined) {

					// Check enrollment
					if ('open' === courseType) {
						userAccess = userList.allUserIds;
					} else {
						userAccess = dataObject.userList.course_user_access_list[courseID];
					}

					jQuery.each(userAccess, function (key, userID) {
						if (typeof userList.userOverview[userID] === 'undefined') {
							return true;
						}
						enrolled++;
					});
				} else {
					enrolled = 0;
				}
			}
		}

		// add amount user enrolled to course
		dataObject.addToCourseList(courseID, 'usersEnrolled', enrolled);

		if (typeof dataObject.userList.courseQuizAverages !== 'undefined' && typeof dataObject.userList.courseQuizAverages[courseId] !== 'undefined') {
			if ('false' === dataObject.userList.courseQuizAverages[courseId]) {
				avgQuiz = '';
			} else {
				avgQuiz = dataObject.userList.courseQuizAverages[courseId] + '%';
			}
		}


		if ("1" !== reportingApiSetup.optimized_build) {
			courseAssociatedPosts = courseData.associatedPosts;
			userAverages.cumalitivePercentage = 0;
			userAverages.amountQuizzes = 0;

			if (0 === userAverages.amountCompletionTime || 0 === userAverages.cumalitiveCompletionTime) {
				avgCompletionTime = '';
			} else {
				avgCompletionTime = dataObject.formatSecondsToDate(userAverages.cumalitiveCompletionTime / userAverages.amountCompletionTime);

			}

			// add average timer results to course
			dataObject.addToCourseList(courseID, 'userCompletionTimeAverage', avgCompletionTime, 'string');

			userAverages.cumalitiveTimeSpent = 0;
			userAverages.amountTimeSpent = 0;

			jQuery.each(userAccess, function (innerIndex, userID) {

				if (typeof userList[userID] === 'undefined') {
					return true;
				}

				if (userList[userID][courseID] && userList[userID][courseID].time_spent) {

					userAverages.cumalitiveTimeSpent += userList[userID][courseID].time_spent;
					userAverages.amountTimeSpent++;

				}
			});

			if (0 === userAverages.amountTimeSpent || 0 === userAverages.cumalitiveTimeSpent) {
				avgTimeSpent = '';
			} else {
				avgTimeSpent = dataObject.formatSecondsToDate(userAverages.cumalitiveTimeSpent / userAverages.amountTimeSpent);
			}
		}

		userAverages.cumalitiveCompletionTime = 0;
		userAverages.amountCompletionTime = 0;

		jQuery.each(userAccess, function (innerIndex, userID) {

			if (typeof userList[userID] === 'undefined') {
				return true;
			}

			if (userList[userID][courseID] && userList[userID][courseID].completed_time) {

				userAverages.cumalitiveCompletionTime += userList[userID][courseID].completed_time;
				userAverages.amountCompletionTime++;

			}
		});

		// add average time spent results to course
		dataObject.addToCourseList(courseID, 'userTimeSpentAverage', avgTimeSpent, 'string');

		if (typeof userList.completed[courseID] !== 'undefined') {
			completed = userList.completed[courseID];
		} else {
			completed = 0;
		}

		if (typeof userList.inProgress[courseID] !== 'undefined') {
			inProgress = userList.inProgress[courseID];
		} else {
			inProgress = 0;
		}

		notStarted = enrolled - (completed + inProgress);


		// add amount user notStarted course
		dataObject.addToCourseList(courseID, 'notStarted', notStarted);

		// add amount user inProgress course
		dataObject.addToCourseList(courseID, 'inProgress', inProgress);

		// add amount user completed course
		dataObject.addToCourseList(courseID, 'completed', completed);


		if (0 == enrolled || 0 == completed) {
			completion = 0 + '%';
		} else {
			completion = Math.ceil( (completed / enrolled) * 100 ) + '%';
		}


		// add completion percentage of course
		dataObject.addToCourseList(courseID, 'completion', completion, 'string');

		//tableData[i] = [courseID, courseName, enrolled, notStarted, inProgress, completed, avgQuiz, avgCompletionTime, avgTimeSpent, completion];

		// Details
		let details = `<span class="reporting-table-see-details">${ reportingApiSetup.localizedStrings.tablesButtonSeeDetails }</span>`;

		// Course name
		courseName = `<span class="reporting-table-see-details">${ courseName }</span>`;

		tableData.push(
			{
				ID: courseID,
				course: courseName,
				enrolled: enrolled,
				notStarted: notStarted,
				inProgress: inProgress,
				completed: completed,
				avgQuizScore: avgQuiz,
				percentComplete: completion,
				details: details
			}
		);

		i++;
	});

	dataObject.addToDataTables('coursesOverviewTable', tableData);

	return tableData;

}

export {
	coursesOverviewTableHeadings,
	coursesOverviewTableData,
};
